import { takeLatest, put, apply, select } from '@redux-saga/core/effects';
import ReCaptchaService from '../../../services/ReCaptchaService';
import Types from '../../types';
import { getQueryParams } from '../../utils/selectors';
import { isInCheckoutFlow } from '../../utils/redirect';

export function* checkIfRequiresReCaptcha() {
  const queryParams = yield select(getQueryParams);
  const inCheckout = isInCheckoutFlow(queryParams);
  if (inCheckout) return false;

  const requiresReCaptcha = yield apply(ReCaptchaService, 'requiresReCaptcha');
  if (requiresReCaptcha) {
    yield put({ type: Types.RECAPTCHA_REQUIRED });
  }
  return false;
}

function* reCaptchaSaga() {
  yield takeLatest(Types.RECAPTCHA_CHECK, checkIfRequiresReCaptcha);
}

export default reCaptchaSaga;
